module.exports = __webpack_public_path__ + "static/media/trc-logo-white-red.13b4c94c.svg";